import { memo, useEffect } from 'react';

import { FolderId, SubfolderIdData, SubfolderNameData } from 'modules/domains/foldering';
import { ChildItem, TreeViewQueryResponse } from './types';

export type TreeFolderProps = {
  id: FolderId;
  /** the query to use to retrieve additional folder information */
  query: (folderId: FolderId) => TreeViewQueryResponse;
  /** set the child items */
  setChildItems: (childItems: ChildItem[]) => void;
  /** set the child folders */
  setChildFolders: (childFolders: (SubfolderIdData & SubfolderNameData)[]) => void;
};

/** using this conditionally rendered component allows us to use the query hook
 * only as needed without breaking any rules of React
 */
export const TreeSeed = memo(({ id, query, setChildItems, setChildFolders }: TreeFolderProps) => {
  const {
    childFolders = [],
    // folderData = {
    //   ancestors: [],
    //   id: rootFolderId,
    //   name: '',
    // },
    childItems = [],
  }: TreeViewQueryResponse = query(id) || {};

  useEffect(() => {
    setChildItems(childItems);
    setChildFolders(childFolders);
  }, [childItems, childFolders, setChildItems, setChildFolders]);

  return null;
});
